<template>
  <v-app>
    <Header />
    <MessagePopup />
    <v-content>
      <router-view />
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Header from './components/App/Header'
import Footer from './components/App/Footer'
import MessagePopup from './components/App/MessagePopup'
export default {
  name: 'App',

  components: {
    Header,
    Footer,
    MessagePopup
  },

  data: () => ({
    //
  }),
  mounted() {}
}
</script>
